import type { OcrTextMapPage } from '@/domain/documents/queries';
import {
  displayedOcrPolygonRect,
  type DisplayedPageLayout,
} from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/ocrGeometry';
import {
  ExtractedFieldHighlightsRoot,
  ExtractedFieldHighlight,
} from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/ExtractedFieldHighlights/StyledComponents';

type Props = {
  ocrPage: OcrTextMapPage;
  layout: DisplayedPageLayout;
};

const ExtractedFieldHighlights = ({ ocrPage, layout }: Props) => (
  <ExtractedFieldHighlightsRoot>
    {Object.entries(ocrPage.extractedFields).map(([key, box]) => (
      <ExtractedFieldHighlight key={key} aria-hidden style={displayedOcrPolygonRect(ocrPage, layout, box)} />
    ))}
  </ExtractedFieldHighlightsRoot>
);

export default ExtractedFieldHighlights;
